/** 
* 自动生成文件，请勿修改 
* @name: 资产:设备申领模块
* @description: 设备申领模块-增删改查
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:8条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const deviceApply = { 
	/** 1 summary:申领申请-查询需要我审批且已到达我这里的申请-不分页	method:post */ 
	queryMyApproval : new APIObject("/api/deviceApply/queryMyApproval.do"), 
	/** 2 summary:查询-分页	method:post */ 
	queryPage : new APIObject("/api/deviceApply/queryPage.do"), 
	/** 3 summary:删除-单条（未被审核时才能删除）	method:post */ 
	delete : new APIObject("/api/deviceApply/delete.do"), 
	/** 4 summary:查询-单条	method:post */ 
	queryOne : new APIObject("/api/deviceApply/queryOne.do"), 
	/** 5 summary:申领申请-查询需要我审批且已到达我这里的申领申请-分页	method:post */ 
	pageMyApproval : new APIObject("/api/deviceApply/pageMyApproval.do"), 
	/** 6 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/deviceApply/batchDelete.do"), 
	/** 7 summary:新增/修改-单条（设备申领使用）	method:post */ 
	saveOrUpd : new APIObject("/api/deviceApply/saveOrUpd.do"), 
	/** 8 summary:查询-所有数据	method:post */ 
	queryAll : new APIObject("/api/deviceApply/queryAll.do"), 
};
export default deviceApply;